import { NotAuthorized, NotFound, PasswordChanged } from "@modernary/mui/components/common";
import type { RouterOptions } from "vue-router";
import NotImplemented from "./components/NotImplemented.vue";
import complianceEventRoutes, { complianceEventRouteNames } from "./views/complianceEvent/complianceEventRoutes";
import { facilityRouteNames, default as facilityRoutes } from "./views/facility/facilityRoutes";
import Home from "./views/Home.vue";
import permitRoutes, { permitRouteNames } from "./views/permit/permitRoutes";
import { tankRouteNames, default as tankRoutes } from "./views/tank/tankRoutes";

// Troubleshoot your routes using this - https://paths.esm.dev

export const routeNames = {
  home: "Home",
  passwordChanged: "PasswordChanged",
  notAuthorized: "NotAuthorized",
  facilities: {
    ...facilityRouteNames,
  },
  tank: {
    ...tankRouteNames,
  },
  complianceEvent: {
    ...complianceEventRouteNames,
  },
  permit: {
    ...permitRouteNames,
  },
  notImplemented: "NotImplemented",
};

export const routes: RouterOptions["routes"] = [
  { path: "/", component: Home, name: routeNames.home, meta: { title: "Home" } },
  {
    path: "/password-changed",
    component: PasswordChanged,
    name: routeNames.passwordChanged,
    meta: { title: "Password Changed" },
  },
  {
    path: "/unauthorized",
    component: NotAuthorized,
    name: routeNames.notAuthorized,
    meta: { title: "Not Authorized" },
  },
  {
    path: "/not-implemented",
    component: NotImplemented,
    name: routeNames.notImplemented,
    meta: { title: "Not Implemented" },
  },
  ...facilityRoutes,
  ...tankRoutes,
  ...complianceEventRoutes,
  ...permitRoutes,
  { path: "/:path(.*)", component: NotFound },
];
